import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Store } from '@ngrx/store';
import { DialogService } from 'primeng/dynamicdialog';
import { Observable, of, switchMap, take } from 'rxjs';

import { unsavedChangesFeature } from '../state/unsaved-changes.reducer';

import { UNSAVEABLE_JOB_PAGE_CHANGE_SOURCES } from './job-tool.reducer';
import { JobComponent } from './job.component';
import { LeaveJobConfirmComponent } from './leave-job-confirm/leave-job-confirm.component';



export interface ComponentCanDeactivate {
  canDeactivate: () => boolean | Observable<boolean>;
}

@Injectable({
  providedIn: 'root'
})
export class LeaveJobGuard {

  public constructor(
    public dialogService: DialogService,
    public store: Store,
  ) {}

  canDeactivate(
    _component: JobComponent,
    currentRoute: ActivatedRouteSnapshot,
    _currentState: RouterStateSnapshot,
    nextState: RouterStateSnapshot,
  ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    const currentJobId = this.getJobId(currentRoute);
    const nextJobId = this.getJobId(nextState.root);

    // Do not show confirmation dialog when navigating between job pages for the same job.
    if (currentJobId && nextJobId && currentJobId === nextJobId) {
      return true;
    }

    return this.store.select(unsavedChangesFeature.selectQueue).pipe(
      take(1),
      switchMap((changes) => {

        const hasChanges = changes
          .filter((c) => c.jobId === currentRoute.params.jobId)
          .filter((c) => !UNSAVEABLE_JOB_PAGE_CHANGE_SOURCES.includes(c.source))
          .length > 0;

        if (!hasChanges) {
          return of(true);
        }

        const dialogRef =  this.dialogService.open(LeaveJobConfirmComponent, { width: '46rem', });

        if (!dialogRef) { return of(true) }

        return dialogRef.onClose;
      }),
    );
  }

  private getJobId(route: ActivatedRouteSnapshot | null): string | undefined {
    let current: ActivatedRouteSnapshot | null = route;

    while (current) {
      if (current.params?.jobId) {
        return current.params.jobId;
      }

      current = current.firstChild;
    }

    return undefined;
  }
}
